module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (30).880c1d47.jpg";